import { graphql } from "react-relay";

export const UpdateAccountMutation = graphql`
  mutation UpdateAccountMutation($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        ...AccountDetailsMeta_account
        ...AccountDetailsStatus_account
        ...AccountStatusBadge_account
        email
        id
        key
        name
        path
        provider
        securityContext
        statusInfo {
          ...AccountStatus_statusInfo
        }
      }
    }
  }
`;
